import React, { useState } from 'react';
import { Paper, Checkbox, Box, Typography } from '@mui/material';
import { FontSize, useThemeStore } from '../../stores/ThemeStore';

const chipFontSizeMapping = {
  [FontSize.Small]: 16,
  [FontSize.Big]: 20,
};

type Props = {
  title: string;
  text: string;
  consented: boolean;
  onChange: (checked: boolean) => void;
};

function base64DecodeUtf8(s: string) {
  let bytes = new Uint8Array(atob(s).split("").map(c => c.charCodeAt(0)));
  return new TextDecoder("utf-8").decode(bytes);
}

const RsCheckbox: React.FC<Props> = ({ title, text, consented, onChange }) => {
  const {currentFontSize} = useThemeStore()
  const [checked, setChecked] = useState<boolean>(consented);
  const decodedText = base64DecodeUtf8(text);

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = event.target.checked;
    setChecked(isChecked);
    onChange(isChecked);
  };

  return (
    <Paper elevation={2}>
      <Box px={3} py={2}>
        <Box display="flex" alignItems="center" mb={1}>
          <Checkbox
            color="primary"
            checked={checked}
            onChange={handleCheckboxChange}
          />
          <Typography variant="h6" color="textPrimary">{title}</Typography>
        </Box>
        <Typography color="textSecondary" style={{fontSize: chipFontSizeMapping[currentFontSize]}}>
          {decodedText}
        </Typography>
      </Box>
    </Paper>
  );
}

export default RsCheckbox;
